import React, { useEffect, useState } from 'react';
import './header.css';
import { useTranslation } from "react-i18next";

const Header = () => {


    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("librVerd");

    return (
        <div class="NLV_header">
            <div class="NLV_titulo">
                <h1>{(t('header.titulo'))}</h1>
            </div>
            <div class="NLV_parrafo">
                <p>
                    <b>{(t('header.parrafo1'))}
                    
                        {(t('header.span1'))}</b><br/> 
                        <span><i> 
                        {(t('header.span2'))}
                    
                    {(t('header.parrafo2'))}
                    <br/>
                    {(t('header.parrafo3'))}</i></span>
                </p>
            </div>
            <div class="NLV_button">
                <a href='https://www.gandhi.com.mx/ideas-que-transforman-sociedades-para-cambiar-al-mundo' target='_blank'>
                    <button class="NVL_button_bt">{(t('header.button'))}</button>
                </a>
            </div>
            <div class="NLV_img">
                <img src='\assets\imgs\nuevo_libro\header_libroVerde.png' class="NVL_img_libros"/>
            </div>
        </div>
    )
}

export default Header
